<template>
      <div>
        <div class="Table-Info">
            <Tables  ref="tableocurrence"
            style="font-family:'Segoe UI'"
            :columns="columns"
            :showSearch="false"
            :showPrint="false"
            :showDownload="false"
            @Load="onload"
            :showFullscreen="false"
            >
            <tr v-for="data in dataOcorrencia" :key="data.id">
              <TableColumn v-on:Edit="$emit('Details', data)"  :IsText="true" :value="data.codigo"></TableColumn>
              <TableColumn v-on:Edit="$emit('Details', data)"  :IsText="true" :value="data.nomeMorador"></TableColumn>
              <TableColumn v-on:Edit="$emit('Details', data)"  :IsText="true" :value="data.empreendimentoNovaUnidade != null ? data.empreendimentoNovaUnidade.nomeEmpreendimento : 'N/D' "></TableColumn>
              <TableColumn v-on:Edit="$emit('Details', data)"  :IsText="true" :value="data != null ? data.nomeUnidade : 'N/D' "></TableColumn>
              <TableColumn v-on:Edit="$emit('Details', data)"  :newState="true" :colorStatus="data.colorStusOcorencia" :descriptionNewStatus="data.statusOcorrenciaName"></TableColumn>
              <TableColumn v-on:Edit="$emit('Details', data)"  :IsText="true" :value="data.dataAcaoFormatadaNotHour"></TableColumn>
              <TableColumn v-on:Edit="$emit('Details', data)"  :IsText="true" :value="data.dataAvaliacaoTecnicaFormatada"></TableColumn>
              <TableColumn v-on:Edit="$emit('Details', data)"  :IsText="true" :value="data.dataSolicitacaoFormatada"></TableColumn>
              <TableColumn v-on:Edit="$emit('Details', data)"  :IsText="true" :value="data.dataTerminoFormatada"></TableColumn>
              <!-- <TableColumn v-on:Edit="$emit('Details', data)"  :IsText="true" :value="data.patologiaText"></TableColumn> -->
              <TableColumn v-on:Edit="$emit('Details', data)"  :IsText="true" :value="data.engenheiro == null ? 'N/D' : data.engenheiro.nome "></TableColumn>
              <!-- Unir SAP aqui é escolha 100% manual (só 16 empreendimentos cadastrados no SAP, sem
                   validação contra a obra/empreendimento do chamado) — por isso restrito a ADM QMA. -->
              <TableColumn @Delete="Delete(data)"  :FixedIconTable="false"  classCss="text-center" :IsActionsButtons="true" :HasDelete="false" :HasDocumentDelete="!hasRole(roles.RW_REAL_ESTA_USER_OBRA)" :value="data" :IsDocumentActions="true" :HasDetails="true" :HasAssociar="hasRole(roles.QMA_SEARCH_CONTROLLER_APPROVAL)" :AssociarUnido="data.temVinculoSap" v-on:Details="$emit('Details', data)" v-on:Associar="abrirUnir(data)" :HasChange="false"></TableColumn>
              </tr>
          </Tables>
        </div>

        <b-modal ref="modalUnirSap" title="Unir chamado com casa do SAP" hide-footer size="lg">
          <b-form-group label="Empreendimento (SAP)">
            <b-form-select v-model="unir.codEmp" :options="unir.empreendimentos" @change="onChangeEmpreendimento">
              <template slot="first"><option :value="null">Selecione...</option></template>
            </b-form-select>
          </b-form-group>
          <b-form-group label="Unidade / Casa (SAP)" v-if="unir.codEmp !== null">
            <b-form-select v-model="unir.casaIdx" :options="unir.unidadesOptions">
              <template slot="first"><option :value="null">Selecione...</option></template>
            </b-form-select>
          </b-form-group>
          <div v-if="unir.casaIdx !== null && unir.unidades[unir.casaIdx]" class="small text-muted mb-3">
            Obra {{ unir.unidades[unir.casaIdx].obraRefSap }} · Quadra {{ unir.unidades[unir.casaIdx].quadra }} ·
            Fase {{ unir.unidades[unir.casaIdx].fase }} · {{ unir.unidades[unir.casaIdx].tipoImovel }}
            <span v-if="unir.unidades[unir.casaIdx].jaVinculada"> · (casa já unida)</span>
          </div>
          <div class="text-right">
            <b-button variant="secondary" class="mr-2" @click="$refs.modalUnirSap.hide()">Cancelar</b-button>
            <b-button variant="third" :disabled="unir.casaIdx === null" @click="confirmarUnir">Unir</b-button>
          </div>
        </b-modal>
      </div>
</template>

<script>
import tableocurrence from './tableocurrence'
export default tableocurrence
</script>

<style scoped>
#body-details{
    height: 60vh;
}
#head-details{
  display: flex;
  justify-content: space-between;
}

.text-center.PositionBottom {
    padding-top: 20px;
}

.card-bottom-radius-8 {
    width: fit-content;
}

</style>



// WEBPACK FOOTER //
// src/views/private/realestate/ocurrence/components/tableocurrence/tableocurrence.vue